import { useHead } from '@unhead/vue';

export default function useRecaptcha() {
  useHead({
    script: [
      {
        key: 'recaptchaUrl',
        src: 'https://www.google.com/recaptcha/api.js?render=6Lcs9awZAAAAAIg5qOpFkbrTFWfXJZ-bI5TQkXbs',
        defer: true,
      },
    ],
  });
}
